"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._Messages = exports._DataSetValidation = void 0;
var translation_1 = __importDefault(require("@services/translation"));
exports._DataSetValidation = {
    firstName: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidFirstname'),
    },
    lastName: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidLastname'),
    },
    dateOfBirth: {
        regex: /^\d{4}-\d{2}-\d{2}$/,
        regexError: translation_1.default.t('noValidBirthday'),
    },
    street: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidStreetName'),
    },
    houseNumber: {
        regex: /^.+$/,
        regexError: translation_1.default.t('noValidHouseNumber'),
    },
    zipCode: {
        regex: /^.{3,7}$/,
        regexError: translation_1.default.t('noValidZIP'),
    },
    city: {
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidCity'),
    },
    bankAccount: {
        accountHolder: {
            regex: /^\D{2,}$/,
            regexError: translation_1.default.t('noValidName'),
        },
        bankName: {
            regex: /^\D{2,}$/,
            regexError: translation_1.default.t('noValidBankName'),
        },
        bic: {
            regex: /^([A-Z0-9]{8}|[A-Z0-9]{11})$/,
            regexError: translation_1.default.t('noValidBic'),
        },
        iban: {
            regex: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{0,30}$/,
            regexError: translation_1.default.t('noValidIBAN'),
        },
    },
    email: {
        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
        regexError: translation_1.default.t('noValidEmail'),
    },
    phonePrivate: {
        regex: /^\d{5,}$/, // at least 5 numbers 0-9
        regexError: translation_1.default.t('noValidPhoneNumber'),
    },
};
exports._Messages = {
    GetError: translation_1.default.t("An unexpected error occurred while retrieving your data. We're sorry for the inconvenience"),
    PostError: translation_1.default.t("An unexpected error occurred while posting your amendments. We're sorry for the inconvenience"),
    PostSuccess: translation_1.default.t('Your amendments were successfully posted'),
};
